import $ from "jquery";

export default class Landing {
  constructor(){
    this.config = {
      heroContent: '.landing__hero__content',
      heroButton: '.landing__hero__button',
      firstChildImage: '.landing__hero__content:first-child .landing__hero__content__book__img',
      heroContentFirstChild: '.landing__hero__content:first-child',
      heroContentLastChild: '.landing__hero__content:last-child',
      slideshow: '#js__hero__slideshow',
      animationTopHeight: '48px',
      bookImage: '.landing__hero__content .landing__hero__content__book__img',
      menu: '.header__nav'
    }
  }
  getNextSlide(){
    $(this.config.heroContentFirstChild).hide().css({opacity: 0}).next().css({display: 'flex'}).animate({
      opacity: 1
    }, 200, ()=>{
      // set the hidden books back to 48px and animate the new one up
      $(this.config.firstChildImage).animate({top: '0'}, 100);
      $(this.config.bookImage).css({top: '48px'}, 100);
    }).end().appendTo(this.config.slideshow);
  }

  getPrevSlide() {
    $(this.config.heroContentFirstChild).hide().css({opacity: 0});
    $(this.config.heroContentLastChild).prependTo(this.config.slideshow).hide();
    $(this.config.heroContentFirstChild).css({display: 'flex'}).animate({ opacity: 1 }, 200, ()=>{
      // set the hidden books back to 48px and animate the new one up
      $(this.config.firstChildImage).animate({top: '0'}, 100);
      $(this.config.bookImage).css({top: '48px'}, 100);
    });
  }

  initialPageAnimation(){
    $(this.config.firstChildImage).animate({top: '0'}, 100);

    // if only one book exists, hide the arrows
    if($(this.config.heroContent).length === 1){
      $(this.config.heroButton).hide();
    }
  }

  toggleMenu(){
    $(this.config.menu).fadeToggle();
  }
}



// WEBPACK FOOTER //
// src/scripts/Landing.js